import { FiltersRepository as FilterRepo } from '@/domain/analytics'

export class FiltersRepository implements FilterRepo {
  private filterKey = 'analytics-filters'

  getURLSessionFilters(): string {
    return sessionStorage.getItem(`${this.filterKey}`) || ''
  }

  saveURLSessionFilters(filters: string): void {
    sessionStorage.setItem(`${this.filterKey}`, filters)
  }

  clearURLSessionFilters(): void {
    sessionStorage.removeItem(`${this.filterKey}`)
  }
}
